import { cn } from '@/shared/lib/utils';
import { Text } from '../../text';

/**
 * 必須バッジコンポーネント
 *
 * Figma デザインシステム準拠:
 * - https://www.figma.com/design/K9BryoBh0t69xPihm3VBho/DnR-DesignSystem?node-id=2087-44997
 * - 赤いボーダー (border-destructive)
 * - 角丸 4px (rounded)
 * - gap-2 (8px)
 * - text-xs (12px)
 * - 「必須」テキスト表示
 */
export const RequiredLabel = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center gap-2',
        'rounded border border-border-error',
        'px-1 py-px',
        className,
      )}
    >
      <Text color="error" variant="description">
        必須
      </Text>
    </div>
  );
};
